import React from 'react';
import ReactDOM from 'react-dom'; // React 17
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { ChunkErrorBoundary } from 'src/components/ChunkErrorBoundary';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import { NotifierProvider } from 'src/contexts/NotifierContext';
import { AuthProvider } from 'src/contexts/AuthContext';
import * as serviceWorker from 'src/serviceWorker';

import { queryClient } from './queryClient'; // tu QueryClient unificado
import { routerBasename } from 'src/config/routerBase';

ReactDOM.render(
  <ChunkErrorBoundary>
    <HelmetProvider>
      <SidebarProvider>
        <BrowserRouter basename={routerBasename ?? undefined}>
          <NotifierProvider>
            <AuthProvider>          
                <QueryClientProvider client={queryClient}>
                  <App />
                </QueryClientProvider>             
            </AuthProvider>
          </NotifierProvider>
        </BrowserRouter>
      </SidebarProvider>
    </HelmetProvider>
  </ChunkErrorBoundary>,
  document.getElementById('root')
);

serviceWorker.unregister();